const MuiIconButton={
    styleOverrides: {
        sizeSmall: {
            padding: 0,
        },
    },
};
export default MuiIconButton
